import { createFileRoute } from "@tanstack/react-router";
import {
  IntersectionPage,
  buildIntersectionHead,
} from "@/components/IntersectionPage";
import { INTERSECTION_CONFIGS } from "@/lib/intersectionData";

const CONFIG = INTERSECTION_CONFIGS.find((c) => c.slug === "roofing-web-design-colorado-springs")!;

export const Route = createFileRoute("/roofing-web-design-colorado-springs")({
  head: () => buildIntersectionHead(CONFIG),
  component: () => <IntersectionPage config={CONFIG} />,
});
